import { render, staticRenderFns } from "./FilialeManage.vue?vue&type=template&id=35bf00c2&scoped=true&"
import script from "./FilialeManage.vue?vue&type=script&lang=js&"
export * from "./FilialeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf00c2",
  null
  
)

export default component.exports